import CreateApiModule from "@/redux/create-api-module";
import { Config } from "@/utils/config.utils";

import { $AddressBookModuleName } from "./addressbook.types";

const { actions } = CreateApiModule(
    $AddressBookModuleName,
    () => `/customerservice/${Config.general.basestore}/customers/addresses`
);

export const clear = actions.clear;
export const load = actions.load;
export const refetch = actions.refetch;
